var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Invoice.invoice_differenceAdjustment"),
            width: "450px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.adjustBalanceForm,
                "label-width": "100px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_IncludedToBusinessNoP")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "210px" },
                          attrs: { no: "1", placeholder: "请选择" },
                          on: { change: _vm.jobNoChange },
                          model: {
                            value: _vm.adjustBalanceForm.jobUuid,
                            callback: function($$v) {
                              _vm.$set(_vm.adjustBalanceForm, "jobUuid", $$v)
                            },
                            expression: "adjustBalanceForm.jobUuid"
                          }
                        },
                        _vm._l(_vm.jobArray, function(item) {
                          return _c("el-option", {
                            key: item.jobUuid,
                            attrs: { label: item.jobNo, value: item.jobUuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Billing.billingCharge_chargeItem")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "210px" },
                        attrs: {
                          no: "2",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ChargeItem,
                          filterable: "",
                          "callback-params": { key: "chargeItemId" },
                          "callback-method-type": "value",
                          "default-value": _vm.adjustBalanceForm.chargeItemId,
                          "tag-name": "zhName",
                          "options-width": "230px",
                          disabled: true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Billing.billingCharge_currency") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "210px" },
                        attrs: {
                          no: "3",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_Currency,
                          "default-value": _vm.adjustBalanceForm.currency
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.currencyChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Billing.billing_exchangeRate") }
                    },
                    [
                      _c("num-input", {
                        staticStyle: { width: "210px" },
                        attrs: {
                          no: "4",
                          min: 0,
                          precision: 8,
                          "truncated-precision": _vm.exchangeRatePrecision,
                          disabled: _vm.exchangeRateEnable
                        },
                        model: {
                          value: _vm.adjustBalanceForm.exchangeRate,
                          callback: function($$v) {
                            _vm.$set(_vm.adjustBalanceForm, "exchangeRate", $$v)
                          },
                          expression: "adjustBalanceForm.exchangeRate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Billing.billingCharge_difference")
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "210px" },
                        attrs: { no: "5", controls: false, precision: 2 },
                        on: { change: _vm.differenceAmountChange },
                        model: {
                          value: _vm.adjustBalanceForm.differenceAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.adjustBalanceForm,
                              "differenceAmount",
                              $$v
                            )
                          },
                          expression: "adjustBalanceForm.differenceAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.differenceDateVisible,
                          expression: "differenceDateVisible"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("Billing.billingCharge_financialDate")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "210px" },
                        attrs: {
                          no: "6",
                          disabled: _vm.differenceDateDisabled,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.adjustBalanceForm.differenceDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.adjustBalanceForm,
                              "differenceDate",
                              $$v
                            )
                          },
                          expression: "adjustBalanceForm.differenceDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "7" },
                  on: { click: _vm.doSaveAdjustBalance }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "8" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }